import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { Modal } from '@mui/material';
import { Link } from 'react-router-dom';


export default function PaymentReceiptList() {

  const navigate = useNavigate();
  const templateRef = useRef();

  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }

  const encodeExamID = (examid) => {
    return btoa(`${examid}`);
};

const encodeTransactionID = (transaction) => {
    return btoa(`${transaction}`);
};




  const [loading, setlodaing] = useState(false);
  const [getexamData, setExamData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [examid, setExamIdData] = useState('');
  const [transactionReceipt, setSelectedTransactionReceipt] = useState(null);
  const [transationData, setTransationData] = useState(false);

  const [deactiveTab, setdeActiveTab] = useState([]);

  const { http } = Api();





  const handleViewButtonClick = async (examid, transactionId) => {
    setlodaing(true);
    try {
      const response = await http.get(`/College/paymentreprintReceipt`, {
        params: { examid: examid, txnid: transactionId }
      });

      setSelectedTransactionReceipt(response.data);
      setShowModal(true);
      setlodaing(false);

    } catch (error) {
      console.error("Error fetching transaction details:", error);
      toast.error("Failed to load transaction details");
      setlodaing(false);
    }
  };

  const closeModal = () => {

    setShowModal(false);

  };


  useEffect(() => {
    const fetchExamData = async () => {
      try {

        const response = await http.get(`College/ExamlistPaymentReciptReprint`);
        setExamData(response.data);

      }
      catch (error) {

        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error("No active exam found");
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchExamData();
  }, []);

  const handleSelectChange = async (selectedOption) => {

    const examid = selectedOption.value;
    setExamIdData(examid);

    try {
      const response = await http.get(`/College/collegeDisciplineTransDetails`, {
        params: { examid: examid }
      });
      if (response && response.data) {
        setTransationData(response.data);
      }

    } catch (error) {
      if (error.response?.data?.http_status === 401 && error.response.data.status_code === "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);
      } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
        toast.error(error.response.data.message);
      } else if (error.response?.data?.http_status === 500 && error.response.data.status_code === "ERR5") {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const handleGeneratePDFNew = async (examid, transNo, collegename, programme) => {
    setlodaing(true);
    try {
      const response = await http.get('/College/paymentReceiptReprintPdf', {
        params: {
          examid: examid,
          txnid: transNo
        },
        responseType: 'blob'
      });

      if (response && response.data) {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${localStorage.getItem('username')}_${collegename}_${programme}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setlodaing(false);

        return Promise.resolve('PDF generated successfully ');


      }

    } catch (error) {
      console.error('Error generating PDF:', error);
      return Promise.reject('Error generating PDF');
    }
  };


  const toggleTab = (tab) => {
    setdeActiveTab(tabs => {
      if (tabs.includes(tab)) {
        return tabs.filter(t => t !== tab);
      } else {
        return [...tabs, tab];
      }
    });
  };

  
  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (


          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (


          <div className="my-page">

            <div className="container-fluid">

              {showModal && transactionReceipt && (

                <div className="bill-details-modal">
                  <div className="bill-modal-content">
                    <div className="bill-modal-header">
                      <h5 className="bill-modal-title">Bill Details</h5>
                      <button className="bill-close-button" onClick={closeModal}>×</button>
                    </div>

                    <div className="bill-modal-body">
                      <table className="bill-table">
                        <tbody>
                          <tr>
                            <th>Bank Name</th>
                            <td>{transactionReceipt.bankName}</td>
                          </tr>
                          <tr>
                            <th>Transaction Id</th>
                            <td>{transactionReceipt.transId}</td>
                          </tr>
                          <tr>
                            <th>Transaction No.</th>
                            <td>{transactionReceipt.transNo}</td>
                          </tr>
                          <tr>
                            <th>Bank Receipt. No.</th>
                            <td>{transactionReceipt.receiptNo}</td>
                          </tr>
                          <tr>
                            <th>College</th>
                            <td>{transactionReceipt.collegename}</td>
                          </tr>
                          <tr>
                            <th>Programme</th>
                            <td>{transactionReceipt.programme}</td>
                          </tr>
                          <tr>
                            <th>No. of Students</th>
                            <td>{transactionReceipt.studentcount}</td>
                          </tr>
                          <tr>
                            <th>Amount</th>
                            <td>{transactionReceipt.amt}</td>
                          </tr>
                          <tr>
                            <th>Payment Status</th>
                            <td>{transactionReceipt.Status}</td>
                          </tr>
                          <tr>
                            <th>Transaction Date</th>
                            <td>{transactionReceipt.responseTime}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="bill-modal-footer">
                      <button
                        className="bill-print-button"
                        onClick={() => handleGeneratePDFNew(
                          examid,
                          transactionReceipt.transNo,
                          transactionReceipt.collegename,
                          transactionReceipt.programme
                        )}
                      >
                        <i className="fa fa-print" aria-hidden="true"></i> &nbsp;  &nbsp;
                        Print
                      </button>
                    </div>
                  </div>
                </div>
              )}



              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Student Exam Registration Payment List</h5>
                          <div className="buttons-container">
                          </div>
                        </div>
                      </div>


                      <div className="card-body">
                        <div className="card-body pdg">
                          <div className="row">
                            <div className="col-md-1">
                              <label>Exam<span className="errorclr">*</span></label>
                            </div>
                            <div className="col-md-11">
                              <Select
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                id="exam_id"
                                name="exam_id"
                                className="basic-select"
                                classNamePrefix="select"
                                options={getexamData.map(exam => ({
                                  value: exam.examid,
                                  label: exam.examtitle
                                }))}
                                value={getexamData.filter(exam => exam.examid === examid).map(exam => ({
                                  value: exam.examid,
                                  label: exam.examtitle
                                }))}
                                onChange={handleSelectChange}
                                placeholder="Select an exam..."
                              />
                            </div>
                            <div className="accordion dark-accordion" id="outlineaccordion" ref={templateRef}>
                              <div className="accordion-item accordion-wrapper">
                                {transationData ? (
                                  Object.values(transationData).map((item, index) => (
                                    <>
                                      <div className="acodn-bot-line" key={index}>
                                        <h2 className="accordion-header">
                                          <button
                                            className={`accordion-button txt-primary accordion-light-primary`}
                                            type="button"
                                            onClick={() => toggleTab(item.specialisation_display_name)}
                                          >
                                            <span>{item.specialisation_display_name}</span>
                                            <i className={`${deactiveTab.includes(item.specialisation_display_name) ? 'bi bi-chevron-down svg-color' : 'bi bi-chevron-up svg-color'}`}></i>
                                          </button>
                                        </h2>
                                      </div>

                                      <div className={`accordion-collapse collapse ${deactiveTab.includes(item.specialisation_display_name) ? '' : 'show'}`} data-bs-parent="#outlineaccordion">
                                        <div className="accordion-body">
                                          <div className="table-responsive signal-table">
                                            <table className="table table-hover">
                                              <thead>
                                                <tr className="table-active text-center">
                                                  <th scope="col" width="" className='text-center'>Transaction No</th>
                                                  <th scope="col" width="" className='text-center'>Transaction Details</th>
                                                  <th scope="col" width="" className='text-center'>View All</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {Array.isArray(item.txnid) ? (
                                                  item.txnid.map((transaction, Index) => (
                                                    <tr key={Index}>
                                                      <td className='text-center'> {transaction}</td>
                                                      <td className='text-center'> <a style={{ cursor: 'pointer' }} onClick={() => handleViewButtonClick(examid, transaction)}><i className="bi bi-eye-fill svg-color"></i></a></td>                                                     
                                                      <td className="text-center"><Link to={`/college/studentfeedetails/${encodeExamID(examid)}/${encodeTransactionID(transaction)}`} title="View All">
                                                           <i className="bi bi-file-text "></i>&nbsp;View All
                                                          </Link></td>

                                                    </tr>
                                                  ))
                                                ) : (
                                                  <tr>
                                                    <td colSpan="3">No courses available for this subject</td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </>



                                  ))
                                ) : (
                                  <div className="txt-aln pdg11">No Data Found</div>
                                )}
                              </div>
                            </div>




                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>




            </div>
            </div>
          </div>
        )}


      </Template>
    </>
  );
}
